import { AxiosResponse } from 'axios';

import { Lines } from './../pages/outlet-crew/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetSearch extends ResponseREST {
	data: Array<Lines>;
}

export const getSearch = async (
	idScheduler: number,
	productName: string,
): Promise<ResponseSuccessGetSearch> => {
	return axiosInstance
		.get(`search/${idScheduler}?name=${productName}`)
		.then((res: AxiosResponse<ResponseSuccessGetSearch>) => res.data)
		.catch((err) => err);
};
